import { useContext } from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "react-quill/dist/quill.snow.css";
import reportWebVitals from "./reportWebVitals";
import "react-phone-input-2/lib/style.css";
import "react-toastify/dist/ReactToastify.css";
import { Flip, ToastContainer } from "react-toastify";

import { RouterProvider } from "react-router-dom";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { persistor, store } from "./store/store";

import "primereact/resources/themes/lara-light-cyan/theme.css";
import { Loader, LoaderProvider } from "./components/loader/index";
import { ErrorBoundary } from "react-error-boundary";
import ErrorPage from "./custom/ErrorPage";
import "./utils/locale/locale.config";
import RouterContext, { CustomeRoutersProvider } from "./routing/routerContext";
import NotificationProvider from "./components/Socket/notifications/NotificationProvider";
import SocketProvider from "./components/Socket/SocketProvider";

const App = () => {
  const { router } = useContext(RouterContext);
  return <RouterProvider router={router} />;
};

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  // <React.StrictMode>
  <ErrorBoundary fallback={<ErrorPage />}>
    <LoaderProvider>
      <Loader />
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <CustomeRoutersProvider>
            <NotificationProvider>
              <SocketProvider>
                {/* <Whatsapp /> */}
                <App />
                <ToastContainer
                  position="top-center"
                  autoClose={5000}
                  hideProgressBar={false}
                  newestOnTop={false}
                  closeOnClick
                  rtl={false}
                  pauseOnFocusLoss
                  draggable
                  pauseOnHover
                  // theme="colored"
                  transition={Flip}
                />
              </SocketProvider>
            </NotificationProvider>
          </CustomeRoutersProvider>
        </PersistGate>
      </Provider>
    </LoaderProvider>
  </ErrorBoundary>
  // </React.StrictMode>
);

reportWebVitals();
